<template>
	<div>
		<div v-for="(feeObj, feeObj_i) in fees" :key="feeObj_i" class="row mb-2">
			<div v-if="feeObj.value !=0" class="col-4">
				<div class="body-strong text-grey-900 text-start text-nowrap" :class="{ 'font-small': isWiypActive && isLocaleNL }">
					{{ content[`planner_resumeFee_${feeObj.name}`] }}
				</div>
			</div>
			<div v-if="feeObj.value !=0" class="col-8">
				<div class="body-strong text-grey-900 text-end">
					{{
						displayPrice(parseInt(feeObj.value * 100), locale, 2)
					}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import displayPrice from "@/displayPrice/displayPrice";


export default {

	name: "Fees",
	components: {},
	computed: {
		...mapState(["content", 'isWiypActive', 'packCode']),
		...mapGetters(["fees", "locale", "isLocaleNL"]),
	},
	methods: {
		displayPrice,
	},
};
</script>

<style scoped>
.font-small {
	font-size: 13px;
}
</style>